var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldMapDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 640,
    viewBox: "0 0 1440 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "oklch(0.62 0.16 246 / 0.16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237.3,
    cy: 5.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.9,
    cy: 5.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.7,
    cy: 4.2,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.5,
    cy: 7,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.9,
    cy: 5.7,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.1,
    cy: 5.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.6,
    cy: 7.2,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.1,
    cy: 6.2,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.4,
    cy: 3.9,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.5,
    cy: 6.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.2,
    cy: 4.8,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.2,
    cy: 6.7,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.4,
    cy: 6.6,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521,
    cy: 4.6,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.4,
    cy: 6.7,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 3.5,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.6,
    cy: 3.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.8,
    cy: 4.9,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.4,
    cy: 4,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.8,
    cy: 4.6,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598.4,
    cy: 5.3,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 5.8,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621.1,
    cy: 5.5,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 632.8,
    cy: 3,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1128.1,
    cy: 4.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.6,
    cy: 6.3,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.3,
    cy: 6.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.7,
    cy: 18.1,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.8,
    cy: 18,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.3,
    cy: 15,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 14.4,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.2,
    cy: 17.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.1,
    cy: 17.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.8,
    cy: 15.3,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.2,
    cy: 17.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543,
    cy: 14.4,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555.1,
    cy: 14.8,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.3,
    cy: 14.5,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 14.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 587.2,
    cy: 15.1,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.1,
    cy: 15.1,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 14.6,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.3,
    cy: 13.9,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630.9,
    cy: 13.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950.1,
    cy: 14.8,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072,
    cy: 17.5,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.3,
    cy: 17.4,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.4,
    cy: 17.7,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.8,
    cy: 16.9,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.8,
    cy: 13.9,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.4,
    cy: 15.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.3,
    cy: 17.5,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.3,
    cy: 16.6,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 13.8,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1292.6,
    cy: 14.1,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1315.1,
    cy: 15.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.2,
    cy: 28.5,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.1,
    cy: 28.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 25.6,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.4,
    cy: 29,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.7,
    cy: 28.4,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.6,
    cy: 28.8,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 25,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 26.8,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.1,
    cy: 25,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.9,
    cy: 26.3,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.1,
    cy: 28.1,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.1,
    cy: 25.9,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.3,
    cy: 26.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.3,
    cy: 28.7,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.1,
    cy: 26.6,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.6,
    cy: 27.1,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.5,
    cy: 26.3,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.1,
    cy: 26,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.1,
    cy: 25.4,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577,
    cy: 27.6,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589.6,
    cy: 25.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 25.9,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.6,
    cy: 26.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623,
    cy: 28.5,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 27.8,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.6,
    cy: 25.9,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.3,
    cy: 28.1,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1006,
    cy: 25.7,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.8,
    cy: 28.1,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.1,
    cy: 29,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061,
    cy: 25.6,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.8,
    cy: 26.6,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.7,
    cy: 29,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.4,
    cy: 26.5,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1103.7,
    cy: 29.1,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.4,
    cy: 25,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.1,
    cy: 26.5,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.8,
    cy: 28.7,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150,
    cy: 29.2,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.9,
    cy: 26.2,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.6,
    cy: 28.9,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1183.1,
    cy: 24.9,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.7,
    cy: 26.5,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.4,
    cy: 26.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1213.5,
    cy: 24.8,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1225,
    cy: 26.3,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279,
    cy: 26.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1291.4,
    cy: 28.8,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1301.6,
    cy: 26.4,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.3,
    cy: 39,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4,
    cy: 39.2,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 37.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.2,
    cy: 37.4,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.2,
    cy: 36.1,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.7,
    cy: 39.1,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.9,
    cy: 38.2,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.2,
    cy: 40.1,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.8,
    cy: 37.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 37.1,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.3,
    cy: 37.4,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 36.7,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.9,
    cy: 36.9,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 39.7,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.3,
    cy: 37.2,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.5,
    cy: 40.2,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 36.8,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.4,
    cy: 38.7,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.5,
    cy: 39.8,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388,
    cy: 37.1,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.3,
    cy: 36.6,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.1,
    cy: 38.4,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.9,
    cy: 37.4,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.6,
    cy: 37.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.9,
    cy: 39.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.7,
    cy: 36.7,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.9,
    cy: 37.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.8,
    cy: 36.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.2,
    cy: 36.7,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.3,
    cy: 38.2,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.1,
    cy: 36.2,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576.5,
    cy: 38.2,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.6,
    cy: 36.2,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.5,
    cy: 38.9,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.6,
    cy: 37,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.2,
    cy: 40,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.3,
    cy: 40.1,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.7,
    cy: 36.4,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.9,
    cy: 40.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.9,
    cy: 36,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.4,
    cy: 38.2,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.6,
    cy: 37.1,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.6,
    cy: 38.4,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.7,
    cy: 38.7,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038.8,
    cy: 37.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1047.9,
    cy: 38.5,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061,
    cy: 36.8,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073.2,
    cy: 39.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.8,
    cy: 36.6,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.9,
    cy: 36.3,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1103.4,
    cy: 37.7,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.2,
    cy: 37.7,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127,
    cy: 36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.6,
    cy: 36.2,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150,
    cy: 39.2,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.1,
    cy: 36,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 37.5,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1184,
    cy: 36.4,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194.6,
    cy: 40.2,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205,
    cy: 39.4,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1213.7,
    cy: 40.1,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226,
    cy: 40,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.8,
    cy: 36.5,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1249.3,
    cy: 39.9,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1257.1,
    cy: 37.3,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.1,
    cy: 36.5,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.7,
    cy: 37,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.4,
    cy: 36.4,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1303,
    cy: 39.8,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1312.7,
    cy: 37,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1325,
    cy: 37.2,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1334,
    cy: 36.6,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1345.5,
    cy: 39.9,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1358.8,
    cy: 39.7,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.6,
    cy: 38.2,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1413.4,
    cy: 39.7,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1422.3,
    cy: 40.2,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.3,
    cy: 48,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.4,
    cy: 47.9,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.6,
    cy: 51.1,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.4,
    cy: 49.7,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.2,
    cy: 46.8,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.9,
    cy: 47.5,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 48.7,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.1,
    cy: 50.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.4,
    cy: 47.8,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.7,
    cy: 46.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.8,
    cy: 48.4,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.3,
    cy: 48.4,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.8,
    cy: 49.4,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.4,
    cy: 47.7,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 48.9,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.4,
    cy: 50.9,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.9,
    cy: 47.5,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.2,
    cy: 49.6,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.6,
    cy: 50.2,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.6,
    cy: 48,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.9,
    cy: 49.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.3,
    cy: 48.3,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.6,
    cy: 48.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.9,
    cy: 50,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.9,
    cy: 50.8,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 49.1,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.6,
    cy: 47.8,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.1,
    cy: 50.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.9,
    cy: 49.2,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.7,
    cy: 49.5,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 49.6,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.2,
    cy: 49.9,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.8,
    cy: 50.5,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.1,
    cy: 48.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.9,
    cy: 50.5,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.9,
    cy: 48,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.2,
    cy: 48.7,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.3,
    cy: 49.1,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 49.6,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 47.8,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.7,
    cy: 46.9,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.9,
    cy: 47.8,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.9,
    cy: 50,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.1,
    cy: 49.4,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 807.4,
    cy: 50.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.4,
    cy: 50.7,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.1,
    cy: 50.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.8,
    cy: 51,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.3,
    cy: 47.7,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.3,
    cy: 47,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.5,
    cy: 50.4,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896.6,
    cy: 48.1,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.2,
    cy: 47.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.1,
    cy: 47.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.2,
    cy: 48.7,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.9,
    cy: 47.9,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 49.9,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.4,
    cy: 48.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975,
    cy: 49,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 985.5,
    cy: 49.5,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 992.9,
    cy: 48.6,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.7,
    cy: 50.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.2,
    cy: 47.8,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.6,
    cy: 47.2,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051.4,
    cy: 47.5,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1058.8,
    cy: 47.7,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073.2,
    cy: 51.1,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1080.8,
    cy: 49,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094,
    cy: 50.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1103.6,
    cy: 49,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.3,
    cy: 50.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.9,
    cy: 51,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137,
    cy: 47.7,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.9,
    cy: 49,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.3,
    cy: 49.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.2,
    cy: 50.3,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.9,
    cy: 50.3,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.6,
    cy: 48.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.6,
    cy: 48.5,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1216.7,
    cy: 47.2,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.7,
    cy: 46.9,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.7,
    cy: 48,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1249.8,
    cy: 49,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.5,
    cy: 50.7,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.8,
    cy: 48.8,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1281.1,
    cy: 50.1,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.1,
    cy: 49.6,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302.3,
    cy: 48.2,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1312.5,
    cy: 50.5,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1325.7,
    cy: 50.1,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1334.5,
    cy: 48.7,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1348.2,
    cy: 49.3,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1356.4,
    cy: 48.8,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1370.7,
    cy: 47.8,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1378.6,
    cy: 48.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1391.9,
    cy: 50.5,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1400.5,
    cy: 47.5,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1411.9,
    cy: 48.2,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1424.1,
    cy: 47.5,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434.2,
    cy: 47.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.2,
    cy: 59.5,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.7,
    cy: 60.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.3,
    cy: 58.7,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 57.9,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6,
    cy: 61.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.9,
    cy: 60,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.6,
    cy: 59.8,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.4,
    cy: 60.5,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.6,
    cy: 61.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.8,
    cy: 59.7,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.3,
    cy: 61.1,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 58.8,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 61.7,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.2,
    cy: 60.9,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.6,
    cy: 60.8,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.6,
    cy: 59.8,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.2,
    cy: 60.6,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.2,
    cy: 59.6,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.2,
    cy: 60.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.6,
    cy: 58.9,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.7,
    cy: 59.8,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 59.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.8,
    cy: 61.9,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.6,
    cy: 60.7,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.2,
    cy: 59.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 62.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 60.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.5,
    cy: 61.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.9,
    cy: 60.1,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.2,
    cy: 60.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.2,
    cy: 61,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.6,
    cy: 62,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.7,
    cy: 60.8,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.5,
    cy: 61.2,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.3,
    cy: 62.1,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 59.6,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.9,
    cy: 60.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.8,
    cy: 61.3,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.5,
    cy: 58.7,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.4,
    cy: 61.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 632.2,
    cy: 58.4,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 644.5,
    cy: 59.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 655.5,
    cy: 59,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.8,
    cy: 61.2,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.4,
    cy: 61.5,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.6,
    cy: 57.9,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794.9,
    cy: 62,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.8,
    cy: 61.2,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.3,
    cy: 58.5,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.8,
    cy: 61.3,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.7,
    cy: 61.7,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.3,
    cy: 61.5,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.7,
    cy: 60.8,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.1,
    cy: 61.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.7,
    cy: 61.7,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940.2,
    cy: 59,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.8,
    cy: 58.4,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 58.1,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.9,
    cy: 58.4,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984,
    cy: 60,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.2,
    cy: 61.6,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1003.8,
    cy: 61.5,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.9,
    cy: 60.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.7,
    cy: 61.5,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038.4,
    cy: 59.6,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1052,
    cy: 58.1,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.6,
    cy: 60.6,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1069.9,
    cy: 60.5,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.8,
    cy: 61.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.3,
    cy: 62.1,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105,
    cy: 59.9,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.7,
    cy: 57.9,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1128,
    cy: 60.6,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.3,
    cy: 61.6,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.4,
    cy: 59.9,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.1,
    cy: 61.2,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.7,
    cy: 59.7,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.7,
    cy: 60.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194.4,
    cy: 59.1,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.4,
    cy: 59.6,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 59,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226,
    cy: 62.1,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.7,
    cy: 61.3,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247.3,
    cy: 59.2,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.1,
    cy: 60.4,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1270.6,
    cy: 61.3,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279,
    cy: 61,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.7,
    cy: 60.2,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1301,
    cy: 59.1,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1311.8,
    cy: 58.6,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1326.9,
    cy: 60.5,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1336.7,
    cy: 61.3,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1348.8,
    cy: 60.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1358.5,
    cy: 60.6,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1369.9,
    cy: 60.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1380.8,
    cy: 58.7,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1391.7,
    cy: 59.8,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.2,
    cy: 58.2,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1411.6,
    cy: 58,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1425.2,
    cy: 61.8,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1435.7,
    cy: 59.4,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4,
    cy: 71.3,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.8,
    cy: 70.8,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.9,
    cy: 70.5,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.4,
    cy: 72.9,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.1,
    cy: 70.9,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.6,
    cy: 69.2,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.6,
    cy: 69.7,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 68.9,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 71.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.3,
    cy: 73.1,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.2,
    cy: 72.6,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.4,
    cy: 68.9,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 69.9,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 69.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 72.2,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.9,
    cy: 72.6,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259,
    cy: 69.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.6,
    cy: 71.9,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.8,
    cy: 72.9,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.9,
    cy: 73,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 68.9,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.9,
    cy: 71.7,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.4,
    cy: 69.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.2,
    cy: 72,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.5,
    cy: 72.6,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.9,
    cy: 69.1,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.4,
    cy: 72.3,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.3,
    cy: 70.1,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.5,
    cy: 71.8,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.4,
    cy: 72.7,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.4,
    cy: 70,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.4,
    cy: 72.7,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.7,
    cy: 71.1,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.9,
    cy: 71.4,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.6,
    cy: 69.6,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 807.4,
    cy: 71.3,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.6,
    cy: 71.1,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.5,
    cy: 69,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843.2,
    cy: 70.4,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.3,
    cy: 71.6,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.3,
    cy: 69.5,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874.4,
    cy: 70.3,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.1,
    cy: 68.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.9,
    cy: 73.2,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.6,
    cy: 70.9,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.3,
    cy: 70,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930.2,
    cy: 70.7,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 72.2,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952.4,
    cy: 73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.9,
    cy: 69,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.7,
    cy: 69.6,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982.2,
    cy: 69,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.3,
    cy: 72.6,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.8,
    cy: 73,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.8,
    cy: 69.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.4,
    cy: 70.5,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.3,
    cy: 73,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.9,
    cy: 71.3,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.6,
    cy: 73,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072.7,
    cy: 70.5,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.8,
    cy: 69.5,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1096,
    cy: 73.2,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1103.8,
    cy: 69,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.9,
    cy: 70.3,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1128.8,
    cy: 72.8,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.5,
    cy: 69,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.3,
    cy: 71.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.6,
    cy: 73.1,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 69.4,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1183.1,
    cy: 72.9,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.8,
    cy: 70.1,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.4,
    cy: 72.1,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1213.3,
    cy: 70.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.9,
    cy: 69.3,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1236.9,
    cy: 69.5,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1246.8,
    cy: 69.4,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.8,
    cy: 68.9,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271,
    cy: 69.7,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279,
    cy: 72.9,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.8,
    cy: 72.9,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1304.6,
    cy: 72.7,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1312.4,
    cy: 70.8,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1323.2,
    cy: 72.9,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1337.5,
    cy: 71.6,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346.8,
    cy: 70.3,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1359.4,
    cy: 70.9,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1369.6,
    cy: 69.4,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1378.8,
    cy: 69,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1391.9,
    cy: 71.2,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1400.4,
    cy: 72.6,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1412,
    cy: 70.6,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1422.5,
    cy: 70,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1436.5,
    cy: 70.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.9,
    cy: 81.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 80.7,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.4,
    cy: 84.2,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.2,
    cy: 83.9,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.2,
    cy: 81.1,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 81.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.1,
    cy: 79.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.4,
    cy: 81.3,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.4,
    cy: 79.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 82.1,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.6,
    cy: 81.7,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 80.8,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.3,
    cy: 80.4,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.6,
    cy: 83.2,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.9,
    cy: 80.7,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.1,
    cy: 80.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 82,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 80.7,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 82.9,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.4,
    cy: 82.4,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.7,
    cy: 80.1,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 81.6,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 80,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.4,
    cy: 81.3,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.5,
    cy: 83.6,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.8,
    cy: 82.1,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.8,
    cy: 82.1,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.3,
    cy: 82.9,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.6,
    cy: 80.3,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.9,
    cy: 83.4,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.2,
    cy: 81.3,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.9,
    cy: 81.3,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.7,
    cy: 84.1,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.3,
    cy: 83.8,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.4,
    cy: 83.5,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.9,
    cy: 81.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.6,
    cy: 81.4,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.1,
    cy: 80.1,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.7,
    cy: 82,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 860.9,
    cy: 80.4,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 876.1,
    cy: 83.2,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.9,
    cy: 82.6,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.4,
    cy: 83.7,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.7,
    cy: 80,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.6,
    cy: 81,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.8,
    cy: 81,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940.2,
    cy: 83.9,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 951.5,
    cy: 80.9,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.1,
    cy: 81.7,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975,
    cy: 81.1,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983.1,
    cy: 82.6,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.3,
    cy: 82.4,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008,
    cy: 82.1,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016,
    cy: 81.9,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.1,
    cy: 80.5,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.3,
    cy: 80.4,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.1,
    cy: 81.6,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.1,
    cy: 80.9,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.2,
    cy: 82.2,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.5,
    cy: 82.5,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.3,
    cy: 82.7,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1103.7,
    cy: 82.9,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.8,
    cy: 82.2,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.5,
    cy: 81.9,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.2,
    cy: 80.9,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.8,
    cy: 82.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.5,
    cy: 82.4,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1168.9,
    cy: 81.4,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1183.6,
    cy: 80.8,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.2,
    cy: 82,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.1,
    cy: 84.1,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.1,
    cy: 83.2,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.5,
    cy: 80.1,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.6,
    cy: 81.7,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1246.1,
    cy: 81.5,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.7,
    cy: 83,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.3,
    cy: 80.8,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1283,
    cy: 83.1,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.5,
    cy: 81.3,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302.4,
    cy: 82.8,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1314.5,
    cy: 83.5,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1326.4,
    cy: 82.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1337.1,
    cy: 83.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1381.6,
    cy: 79.8,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1392.2,
    cy: 82.4,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1402,
    cy: 84,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.4,
    cy: 91.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.1,
    cy: 93.1,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.8,
    cy: 92.5,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.4,
    cy: 93.4,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.3,
    cy: 95,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.8,
    cy: 93.1,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.2,
    cy: 92.4,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.6,
    cy: 93.3,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.3,
    cy: 94.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 92.9,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.7,
    cy: 93.5,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.2,
    cy: 92.3,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.1,
    cy: 94.4,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.6,
    cy: 92.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.1,
    cy: 94.4,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.1,
    cy: 91.3,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.6,
    cy: 91.6,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.6,
    cy: 93.5,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.4,
    cy: 95.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.6,
    cy: 91,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.6,
    cy: 94.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.1,
    cy: 93.8,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698.4,
    cy: 95,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775,
    cy: 95,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.9,
    cy: 92.5,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.9,
    cy: 94.3,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.9,
    cy: 91.6,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.4,
    cy: 91.6,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854.1,
    cy: 92.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.3,
    cy: 91.3,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874.1,
    cy: 92.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 884.6,
    cy: 91.1,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.3,
    cy: 94.4,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.3,
    cy: 91.9,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.6,
    cy: 92,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927.8,
    cy: 91,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940.7,
    cy: 92.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.5,
    cy: 93.9,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.2,
    cy: 92,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.5,
    cy: 91.4,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983.8,
    cy: 94.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.3,
    cy: 91.5,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.4,
    cy: 94,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.5,
    cy: 95,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.7,
    cy: 95,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039,
    cy: 91.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.8,
    cy: 91.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.9,
    cy: 91.9,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073.8,
    cy: 93.4,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.4,
    cy: 91.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.5,
    cy: 91.7,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.6,
    cy: 91.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.1,
    cy: 93.2,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 94.2,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.5,
    cy: 93.7,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.3,
    cy: 92.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.5,
    cy: 91.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.6,
    cy: 94.5,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.2,
    cy: 93.7,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.3,
    cy: 93.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.4,
    cy: 93,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.1,
    cy: 91.1,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1225.2,
    cy: 91.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.4,
    cy: 94,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247,
    cy: 92.6,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.8,
    cy: 94.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.7,
    cy: 94.6,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279.4,
    cy: 92,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1356.3,
    cy: 94.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.3,
    cy: 105.3,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.7,
    cy: 104.1,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.9,
    cy: 102.4,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.2,
    cy: 102,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.9,
    cy: 105.3,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.9,
    cy: 104.2,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.1,
    cy: 104.6,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.2,
    cy: 102.9,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.1,
    cy: 103.4,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.6,
    cy: 102.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.2,
    cy: 102.4,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.9,
    cy: 104.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.8,
    cy: 102.9,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.1,
    cy: 103.8,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.9,
    cy: 103.3,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.1,
    cy: 105.7,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.4,
    cy: 104.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.4,
    cy: 103.8,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.2,
    cy: 105.5,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.3,
    cy: 103.1,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.4,
    cy: 102.7,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.1,
    cy: 103,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.7,
    cy: 104.9,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.3,
    cy: 104.6,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.4,
    cy: 104.9,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.4,
    cy: 102.2,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.8,
    cy: 102.5,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.8,
    cy: 106.1,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.2,
    cy: 102,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.7,
    cy: 102.6,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864,
    cy: 101.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.5,
    cy: 105.6,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.3,
    cy: 103.7,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895,
    cy: 104.7,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907.1,
    cy: 103.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 917.3,
    cy: 103.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.7,
    cy: 105.4,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.8,
    cy: 102.5,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950.1,
    cy: 103.7,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.3,
    cy: 103.3,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.7,
    cy: 102.2,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983.2,
    cy: 103.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 997.1,
    cy: 105.8,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.6,
    cy: 106.1,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019,
    cy: 104.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.4,
    cy: 102.1,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.8,
    cy: 104.5,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.1,
    cy: 104.3,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1063,
    cy: 103.9,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072.6,
    cy: 103.1,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.3,
    cy: 105.7,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1091.9,
    cy: 102.6,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.8,
    cy: 103.8,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.2,
    cy: 104.7,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.4,
    cy: 104.4,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.6,
    cy: 104.1,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.3,
    cy: 103.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.3,
    cy: 102.6,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.7,
    cy: 104.2,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.3,
    cy: 105.6,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.9,
    cy: 102.2,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.1,
    cy: 102.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 104.2,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.8,
    cy: 104.3,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.3,
    cy: 104.1,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.4,
    cy: 102.2,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.6,
    cy: 102.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1348.2,
    cy: 102.4,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1359.2,
    cy: 102.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1367.8,
    cy: 103.4,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.8,
    cy: 116.4,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 112.9,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.3,
    cy: 113.5,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 116.6,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.3,
    cy: 113,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.6,
    cy: 116.4,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.8,
    cy: 114.5,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.9,
    cy: 113.5,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.5,
    cy: 114.5,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.6,
    cy: 115.5,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.1,
    cy: 114.2,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.8,
    cy: 116.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.4,
    cy: 113,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.5,
    cy: 114.4,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.9,
    cy: 115.3,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.5,
    cy: 114.4,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.8,
    cy: 115.3,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.3,
    cy: 112.9,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 113.4,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.8,
    cy: 114,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433,
    cy: 115,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 115.3,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.1,
    cy: 117,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.2,
    cy: 113,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.3,
    cy: 116.2,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.6,
    cy: 116.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.1,
    cy: 114.2,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.9,
    cy: 114.3,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742.4,
    cy: 117.1,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752.4,
    cy: 116.2,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.7,
    cy: 116.6,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.1,
    cy: 114.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.8,
    cy: 114,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.9,
    cy: 112.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.5,
    cy: 114,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.9,
    cy: 113.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.6,
    cy: 113.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.5,
    cy: 116.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.7,
    cy: 113.7,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864,
    cy: 117,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874.4,
    cy: 113.1,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.4,
    cy: 116.7,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.3,
    cy: 113.4,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.6,
    cy: 115.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.7,
    cy: 115.6,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930.9,
    cy: 113.7,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.2,
    cy: 116.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 951.7,
    cy: 114.6,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.8,
    cy: 114.3,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.1,
    cy: 114.6,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982,
    cy: 115.6,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.3,
    cy: 115,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.4,
    cy: 113.9,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.8,
    cy: 112.9,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.9,
    cy: 115.3,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1041.1,
    cy: 113,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.5,
    cy: 116,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.2,
    cy: 113.2,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.5,
    cy: 113.4,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.2,
    cy: 113.2,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095.4,
    cy: 114.7,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.2,
    cy: 115.4,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.2,
    cy: 115.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.4,
    cy: 114.3,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.1,
    cy: 113.9,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.9,
    cy: 116.2,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.2,
    cy: 114.2,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.2,
    cy: 117.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.8,
    cy: 114,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.1,
    cy: 116.9,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1202.4,
    cy: 112.8,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.9,
    cy: 115.7,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.2,
    cy: 114.4,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1239.2,
    cy: 113.8,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1249.1,
    cy: 113.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.9,
    cy: 113.4,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.1,
    cy: 115,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1281.2,
    cy: 113.6,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1349.1,
    cy: 115,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1358.6,
    cy: 114.3,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.1,
    cy: 123.9,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.3,
    cy: 128.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 127.8,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.5,
    cy: 127,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.2,
    cy: 124.5,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.8,
    cy: 124.2,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.3,
    cy: 127.8,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 127.7,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.1,
    cy: 123.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.8,
    cy: 127.3,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.8,
    cy: 124,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 124.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.7,
    cy: 124.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.9,
    cy: 128.2,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.2,
    cy: 127.7,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.3,
    cy: 125.9,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.4,
    cy: 125.7,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.6,
    cy: 126.8,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.5,
    cy: 127,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 124.3,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.4,
    cy: 126,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.8,
    cy: 125.3,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.7,
    cy: 128.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.7,
    cy: 127,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 124.6,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488,
    cy: 124.1,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 709.6,
    cy: 126.2,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.2,
    cy: 128.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.8,
    cy: 127.1,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.6,
    cy: 126,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.4,
    cy: 128.2,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.8,
    cy: 126.6,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.1,
    cy: 125.5,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.9,
    cy: 125.5,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.1,
    cy: 126.5,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.8,
    cy: 125.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.6,
    cy: 126.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.8,
    cy: 126.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840,
    cy: 127.8,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.9,
    cy: 127,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.1,
    cy: 125.9,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.8,
    cy: 124.4,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.9,
    cy: 126.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896.1,
    cy: 126.1,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.4,
    cy: 124.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.6,
    cy: 127.4,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.8,
    cy: 126.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.4,
    cy: 127.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952.6,
    cy: 124,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.5,
    cy: 127.5,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.4,
    cy: 124.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982.5,
    cy: 124.9,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.3,
    cy: 125.4,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.3,
    cy: 126.1,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.8,
    cy: 124.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.5,
    cy: 128.2,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.9,
    cy: 125.8,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.9,
    cy: 127.3,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1062.1,
    cy: 124.5,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072.8,
    cy: 125.4,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.1,
    cy: 124.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.4,
    cy: 125.3,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.5,
    cy: 123.9,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.7,
    cy: 126.3,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.1,
    cy: 124.6,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139,
    cy: 125,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.2,
    cy: 124.9,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.5,
    cy: 124.2,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171.6,
    cy: 127.6,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.7,
    cy: 125.7,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194.3,
    cy: 126.5,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.4,
    cy: 124,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.7,
    cy: 125.4,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226.9,
    cy: 125.1,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1236.6,
    cy: 126.7,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1249.4,
    cy: 125.4,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.5,
    cy: 126.3,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.9,
    cy: 124.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1291.4,
    cy: 126.7,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.2,
    cy: 136.4,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.8,
    cy: 137,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.4,
    cy: 136.4,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.3,
    cy: 135.7,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.8,
    cy: 137.2,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 136.2,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.1,
    cy: 136.6,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.3,
    cy: 136.2,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323,
    cy: 138.3,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.1,
    cy: 137.9,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.3,
    cy: 137.4,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.8,
    cy: 138.9,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.8,
    cy: 138.7,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.1,
    cy: 136.7,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.6,
    cy: 135,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.6,
    cy: 135.1,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.4,
    cy: 135.6,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.9,
    cy: 137.3,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.3,
    cy: 137,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.2,
    cy: 135.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.3,
    cy: 139,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.9,
    cy: 139.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721.9,
    cy: 137.1,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.1,
    cy: 136.3,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.1,
    cy: 137,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.9,
    cy: 135.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.9,
    cy: 138.6,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.4,
    cy: 137.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.2,
    cy: 135.4,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 138.7,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.5,
    cy: 135.8,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.9,
    cy: 134.9,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.4,
    cy: 139.1,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.3,
    cy: 139,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.7,
    cy: 135,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.3,
    cy: 136.8,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.9,
    cy: 138.1,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.6,
    cy: 138.3,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.1,
    cy: 135.1,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907.3,
    cy: 135.2,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.2,
    cy: 138.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.4,
    cy: 136.8,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.9,
    cy: 137.1,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.2,
    cy: 137.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.4,
    cy: 137.3,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.4,
    cy: 136.4,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.7,
    cy: 135.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.5,
    cy: 138.9,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.3,
    cy: 138.5,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.6,
    cy: 136.9,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.5,
    cy: 135.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.7,
    cy: 135.3,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 137.2,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1059.3,
    cy: 136.9,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.5,
    cy: 137.2,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083,
    cy: 136.4,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.7,
    cy: 136.6,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1103.7,
    cy: 135.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.9,
    cy: 138.6,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127,
    cy: 138.7,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1135.9,
    cy: 139,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.9,
    cy: 138.3,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.3,
    cy: 137.8,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.8,
    cy: 138.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.5,
    cy: 136,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1190.9,
    cy: 136.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.1,
    cy: 136.1,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1216.7,
    cy: 135.2,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226.3,
    cy: 135.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.4,
    cy: 138.2,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.9,
    cy: 135.1,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1257.9,
    cy: 137.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1272.1,
    cy: 135,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 149.2,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.3,
    cy: 148.8,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.9,
    cy: 149.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.6,
    cy: 146.2,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.7,
    cy: 149.5,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.3,
    cy: 148.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.5,
    cy: 149.3,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.8,
    cy: 148,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.9,
    cy: 146.3,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.4,
    cy: 147.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.5,
    cy: 147.8,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.3,
    cy: 146.7,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.4,
    cy: 149.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.5,
    cy: 147.1,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.2,
    cy: 147,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.9,
    cy: 147.7,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.7,
    cy: 149.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.3,
    cy: 148.8,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421,
    cy: 149.4,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.6,
    cy: 147,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 147.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.8,
    cy: 149.7,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.5,
    cy: 149.7,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.5,
    cy: 148,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721.7,
    cy: 149,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.1,
    cy: 146,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 741.2,
    cy: 146.4,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 149.7,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.4,
    cy: 148.4,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.3,
    cy: 146,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.5,
    cy: 149.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.6,
    cy: 147,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.2,
    cy: 147.1,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.2,
    cy: 147.7,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832.1,
    cy: 148.7,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.3,
    cy: 148.8,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.3,
    cy: 149.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.3,
    cy: 147.3,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.4,
    cy: 148.1,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.7,
    cy: 146.5,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 146.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.2,
    cy: 146,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950.1,
    cy: 147.5,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964.1,
    cy: 150,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.6,
    cy: 147.2,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986,
    cy: 146.7,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.2,
    cy: 147.7,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 146.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.5,
    cy: 147.5,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 147,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.7,
    cy: 149.8,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.8,
    cy: 149.5,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.6,
    cy: 149.2,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.2,
    cy: 146.5,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.1,
    cy: 147.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.3,
    cy: 148.8,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.1,
    cy: 147,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.4,
    cy: 149.8,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.1,
    cy: 147.1,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.6,
    cy: 146.9,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.2,
    cy: 146,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.4,
    cy: 148.3,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170.4,
    cy: 149.9,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181,
    cy: 146.9,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.1,
    cy: 148.2,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.1,
    cy: 148.8,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.6,
    cy: 149.4,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.3,
    cy: 147.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.6,
    cy: 150.1,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.6,
    cy: 148.8,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.2,
    cy: 147.5,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.9,
    cy: 149.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.3,
    cy: 147.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.8,
    cy: 160.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.7,
    cy: 160.5,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.4,
    cy: 159.2,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.9,
    cy: 160.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.9,
    cy: 159,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.7,
    cy: 157.1,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.6,
    cy: 160,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4,
    cy: 158.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.1,
    cy: 159.4,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.8,
    cy: 160.6,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.2,
    cy: 160.3,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 158.2,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.1,
    cy: 157.1,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.9,
    cy: 157.4,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.8,
    cy: 159.8,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.9,
    cy: 158.8,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.3,
    cy: 157.6,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.6,
    cy: 158,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.7,
    cy: 160,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.1,
    cy: 158.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.7,
    cy: 159.9,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722.1,
    cy: 158.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732,
    cy: 158.5,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.4,
    cy: 160.5,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.4,
    cy: 156.9,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.7,
    cy: 159.4,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.5,
    cy: 160.3,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.8,
    cy: 157,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.7,
    cy: 159.2,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.1,
    cy: 158.2,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.5,
    cy: 160.7,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.4,
    cy: 157.7,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.8,
    cy: 159.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907.6,
    cy: 159.9,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 157,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.9,
    cy: 158.6,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 951.8,
    cy: 159.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.9,
    cy: 159.7,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 973.8,
    cy: 158.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982.4,
    cy: 160.8,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.4,
    cy: 157.1,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.8,
    cy: 161.1,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1015.8,
    cy: 158.5,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.3,
    cy: 160.4,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.6,
    cy: 160.1,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 157.2,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1063.1,
    cy: 160.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 157,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1081.9,
    cy: 160.9,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.8,
    cy: 159.8,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.9,
    cy: 159.6,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.8,
    cy: 158,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.5,
    cy: 156.9,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.1,
    cy: 157.3,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1151.1,
    cy: 159.9,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.6,
    cy: 160.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.5,
    cy: 159.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.3,
    cy: 160.3,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194.7,
    cy: 160.8,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.8,
    cy: 160.5,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215.2,
    cy: 160.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226,
    cy: 159.5,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.4,
    cy: 160.3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1246.1,
    cy: 157,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.2,
    cy: 158.1,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.5,
    cy: 160.4,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.2,
    cy: 171.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.2,
    cy: 171.7,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.3,
    cy: 170.1,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.3,
    cy: 171.4,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.2,
    cy: 170.6,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 170.2,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293,
    cy: 168.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.1,
    cy: 170.7,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.2,
    cy: 171.9,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.6,
    cy: 171.8,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.8,
    cy: 172.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.2,
    cy: 168.7,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.1,
    cy: 171.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.9,
    cy: 168.9,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.9,
    cy: 172.2,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.6,
    cy: 169.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.8,
    cy: 170.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.1,
    cy: 171.1,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.9,
    cy: 168.9,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.9,
    cy: 170.8,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 687.7,
    cy: 168.6,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.4,
    cy: 168.2,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711.1,
    cy: 169.5,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.7,
    cy: 170.3,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.8,
    cy: 168.1,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.4,
    cy: 171.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.1,
    cy: 168.3,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.9,
    cy: 171.3,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.1,
    cy: 169.5,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.2,
    cy: 168.8,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.8,
    cy: 167.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.7,
    cy: 168.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.9,
    cy: 168.6,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.8,
    cy: 169.7,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.3,
    cy: 168.1,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.4,
    cy: 169.9,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 985.9,
    cy: 170.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.1,
    cy: 168.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.1,
    cy: 170.3,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.6,
    cy: 172,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.6,
    cy: 168.3,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1041,
    cy: 170.1,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.9,
    cy: 168.6,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1062.6,
    cy: 168.7,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.2,
    cy: 169,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.9,
    cy: 169.8,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095,
    cy: 168.1,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.8,
    cy: 169.2,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.7,
    cy: 170.7,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.4,
    cy: 168.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1140.1,
    cy: 169.9,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.6,
    cy: 167.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.7,
    cy: 170.1,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1168.9,
    cy: 169.9,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1183.1,
    cy: 170.2,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.8,
    cy: 170,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.5,
    cy: 170.7,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1213.4,
    cy: 171.3,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1228,
    cy: 171.1,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.6,
    cy: 169.4,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279.8,
    cy: 168,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1291.7,
    cy: 168.4,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 182.4,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.7,
    cy: 181.1,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.3,
    cy: 179.9,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.7,
    cy: 181.4,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.3,
    cy: 182.8,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293,
    cy: 179.6,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.1,
    cy: 182.7,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.3,
    cy: 179.6,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.8,
    cy: 179.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.8,
    cy: 180.4,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.1,
    cy: 181.8,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.1,
    cy: 182.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.5,
    cy: 180.9,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.8,
    cy: 182.3,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.8,
    cy: 180.9,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.8,
    cy: 181.9,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.6,
    cy: 179.6,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.5,
    cy: 182.7,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698.4,
    cy: 179.7,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.9,
    cy: 181.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.3,
    cy: 182.9,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 807.3,
    cy: 181.1,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.9,
    cy: 179.9,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839,
    cy: 179.2,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.5,
    cy: 179.2,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.5,
    cy: 181.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 182.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 180.3,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896,
    cy: 179.6,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.9,
    cy: 181.3,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 179.5,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941,
    cy: 179.8,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952.3,
    cy: 182.3,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.2,
    cy: 181.4,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.6,
    cy: 181.9,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 985.3,
    cy: 182.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993.8,
    cy: 179.2,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.7,
    cy: 181.3,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1015.4,
    cy: 179.6,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.4,
    cy: 179.3,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.6,
    cy: 179.9,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.9,
    cy: 180.7,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.1,
    cy: 182,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1069.9,
    cy: 182,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1081.8,
    cy: 180.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.6,
    cy: 181.8,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.5,
    cy: 182.8,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.7,
    cy: 180.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.7,
    cy: 179.9,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.5,
    cy: 179.8,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.2,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161,
    cy: 183,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.3,
    cy: 180.2,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.2,
    cy: 182,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191,
    cy: 181.5,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215.1,
    cy: 179.5,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.9,
    cy: 182.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.2,
    cy: 179.3,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.9,
    cy: 191.9,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.2,
    cy: 190.5,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.6,
    cy: 191.2,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.6,
    cy: 193.1,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.3,
    cy: 190.6,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.6,
    cy: 193.4,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.6,
    cy: 192.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.8,
    cy: 193.2,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.5,
    cy: 193.8,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337,
    cy: 191.2,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.5,
    cy: 193.4,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 191.4,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.4,
    cy: 191.4,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.5,
    cy: 190.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.8,
    cy: 193.8,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.6,
    cy: 192.6,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 193.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.2,
    cy: 192.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.7,
    cy: 191.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.8,
    cy: 193,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.6,
    cy: 193.7,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.7,
    cy: 190.7,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.7,
    cy: 190.2,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.1,
    cy: 193.4,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.3,
    cy: 191.4,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.8,
    cy: 193.1,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.3,
    cy: 190.8,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.7,
    cy: 194.2,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.7,
    cy: 191.5,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.9,
    cy: 193.9,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.2,
    cy: 193,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.6,
    cy: 192.2,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 192.7,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.4,
    cy: 194,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986.2,
    cy: 192.3,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.3,
    cy: 190.6,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.8,
    cy: 192.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.1,
    cy: 193.6,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.4,
    cy: 193.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.7,
    cy: 189.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 193.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1062.8,
    cy: 194,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072,
    cy: 193.9,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.3,
    cy: 190.4,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.6,
    cy: 193.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.7,
    cy: 192.4,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.9,
    cy: 191,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.6,
    cy: 192.1,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.9,
    cy: 190.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1146.8,
    cy: 191.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161,
    cy: 193.1,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.8,
    cy: 190.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.1,
    cy: 190.6,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.5,
    cy: 193.8,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1202.7,
    cy: 192.4,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1236,
    cy: 193.5,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3,
    cy: 192.8,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.4,
    cy: 204.7,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.3,
    cy: 203.1,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.9,
    cy: 203.6,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.9,
    cy: 202.3,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 203.5,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.3,
    cy: 201.9,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.4,
    cy: 202.5,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.4,
    cy: 204.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.2,
    cy: 202,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.3,
    cy: 204.4,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.5,
    cy: 203.8,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.9,
    cy: 201.6,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.1,
    cy: 204.3,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.4,
    cy: 201.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.1,
    cy: 202,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.7,
    cy: 203.4,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 708.3,
    cy: 202.5,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 204.6,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.8,
    cy: 203.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.4,
    cy: 201.6,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752.5,
    cy: 203.8,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761.8,
    cy: 204.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.5,
    cy: 202,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.8,
    cy: 204.3,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.3,
    cy: 204.4,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 887.2,
    cy: 203.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.2,
    cy: 204.1,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 203.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.5,
    cy: 204.6,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 202,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.9,
    cy: 201.2,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952.9,
    cy: 204.1,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960.5,
    cy: 204.1,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 973.3,
    cy: 204.8,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.4,
    cy: 202.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.9,
    cy: 201.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.2,
    cy: 201.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016,
    cy: 201.3,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.6,
    cy: 202.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 201.9,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051,
    cy: 203.7,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1059.2,
    cy: 203,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073,
    cy: 201.7,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.7,
    cy: 202,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.4,
    cy: 204.8,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.9,
    cy: 205.2,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.7,
    cy: 203.3,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1128.4,
    cy: 204.1,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.8,
    cy: 204.6,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.6,
    cy: 205,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.9,
    cy: 201.3,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.1,
    cy: 201.4,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.8,
    cy: 201,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1195.1,
    cy: 203.2,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1246.2,
    cy: 204.5,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.7,
    cy: 201,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.8,
    cy: 202.9,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.1,
    cy: 216.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.9,
    cy: 216.1,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.1,
    cy: 211.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.2,
    cy: 212.7,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 212.3,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 214.7,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.8,
    cy: 215.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.2,
    cy: 214.8,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.9,
    cy: 211.8,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 213.7,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.1,
    cy: 213.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.3,
    cy: 211.8,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.6,
    cy: 215.8,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.4,
    cy: 212.9,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.2,
    cy: 213.9,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 708.5,
    cy: 213.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721.2,
    cy: 212.8,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 731.7,
    cy: 215.5,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 741.8,
    cy: 214,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.9,
    cy: 214.5,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.6,
    cy: 212.1,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.2,
    cy: 213.3,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.1,
    cy: 215.9,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861,
    cy: 212.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.5,
    cy: 214.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.5,
    cy: 214.6,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.1,
    cy: 214,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.3,
    cy: 212.3,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.1,
    cy: 215,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 212.5,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940.7,
    cy: 213.7,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 951.7,
    cy: 212.2,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.8,
    cy: 211.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.8,
    cy: 213.6,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982.7,
    cy: 212.2,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.8,
    cy: 216.2,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.3,
    cy: 213,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1017.8,
    cy: 212.8,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.6,
    cy: 214.8,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038.7,
    cy: 212.5,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.1,
    cy: 214.2,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1063.2,
    cy: 215.8,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.2,
    cy: 214,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.9,
    cy: 212.7,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.7,
    cy: 214,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.4,
    cy: 213.1,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.9,
    cy: 215.4,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.9,
    cy: 212.4,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.9,
    cy: 212.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.8,
    cy: 214.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.3,
    cy: 216.1,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 214.9,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1183.3,
    cy: 212.3,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1192.2,
    cy: 212,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.4,
    cy: 215,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247.7,
    cy: 211.8,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.3,
    cy: 226,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.9,
    cy: 224.4,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 224.9,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.9,
    cy: 226.7,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.5,
    cy: 226.6,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.7,
    cy: 224.7,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.2,
    cy: 227.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.6,
    cy: 223.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 226.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.6,
    cy: 224.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.7,
    cy: 223.6,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.2,
    cy: 224.4,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685,
    cy: 224.5,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.8,
    cy: 225.5,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.2,
    cy: 226.5,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.2,
    cy: 224.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.3,
    cy: 223.3,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.9,
    cy: 226.1,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752.7,
    cy: 227.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.2,
    cy: 224.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.7,
    cy: 222.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.2,
    cy: 223.2,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.4,
    cy: 224.7,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 224.1,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.9,
    cy: 225.1,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832.1,
    cy: 223.5,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841,
    cy: 225,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.4,
    cy: 226.6,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.7,
    cy: 226.7,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.4,
    cy: 224.3,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.5,
    cy: 225.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895,
    cy: 223.2,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 224.4,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.1,
    cy: 224.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.2,
    cy: 226.5,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950.3,
    cy: 224.6,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 224.4,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.6,
    cy: 223.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.7,
    cy: 225.7,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.8,
    cy: 224.6,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.8,
    cy: 226.3,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.8,
    cy: 226.5,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.4,
    cy: 226,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036.9,
    cy: 223.8,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1052,
    cy: 225.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.8,
    cy: 225,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.9,
    cy: 223.7,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1081.6,
    cy: 225.6,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.9,
    cy: 223.9,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.6,
    cy: 223.4,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.5,
    cy: 223.6,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127,
    cy: 224.2,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.2,
    cy: 223.4,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.9,
    cy: 225.5,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.4,
    cy: 224.2,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171.8,
    cy: 225.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.5,
    cy: 226.2,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.3,
    cy: 223.8,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.7,
    cy: 226.5,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.4,
    cy: 237.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.2,
    cy: 235,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.6,
    cy: 235.9,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.5,
    cy: 236.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.8,
    cy: 235.7,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.8,
    cy: 237.3,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.8,
    cy: 237.4,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 234.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.1,
    cy: 235.8,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.4,
    cy: 237.3,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710,
    cy: 234.3,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 718.8,
    cy: 233.8,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.2,
    cy: 234.3,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742.9,
    cy: 237.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755.2,
    cy: 234.7,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 237.1,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.6,
    cy: 237.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.5,
    cy: 235.2,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.1,
    cy: 238,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.1,
    cy: 235.7,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.7,
    cy: 237.2,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.5,
    cy: 235.9,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.6,
    cy: 235.6,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.7,
    cy: 236.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.8,
    cy: 236.3,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.9,
    cy: 236.3,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.6,
    cy: 234.2,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.4,
    cy: 237.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.6,
    cy: 236.6,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.5,
    cy: 235.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.4,
    cy: 235.1,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.9,
    cy: 237,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.7,
    cy: 236.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.7,
    cy: 236.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 992.9,
    cy: 235.7,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.2,
    cy: 236.4,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.3,
    cy: 234.4,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.7,
    cy: 235.1,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.3,
    cy: 235.1,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.2,
    cy: 237.4,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1059.3,
    cy: 237,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.1,
    cy: 237.9,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1080.9,
    cy: 237,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.4,
    cy: 234.6,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.5,
    cy: 236,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.6,
    cy: 234.3,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.1,
    cy: 235.1,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1140.1,
    cy: 235.5,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.7,
    cy: 234.8,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.1,
    cy: 235.2,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171.6,
    cy: 237.5,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.5,
    cy: 237.1,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1192,
    cy: 234.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1202,
    cy: 235.8,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.2,
    cy: 247.7,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.3,
    cy: 246.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.7,
    cy: 247.8,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 245.6,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 665.4,
    cy: 247,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.9,
    cy: 246.1,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.1,
    cy: 246.4,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700.2,
    cy: 248.7,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.3,
    cy: 248.5,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.9,
    cy: 247.9,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.4,
    cy: 247.9,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742.2,
    cy: 248.4,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.5,
    cy: 247.2,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763,
    cy: 246.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.6,
    cy: 247.9,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.3,
    cy: 248.2,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.6,
    cy: 247.4,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.9,
    cy: 248.4,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.3,
    cy: 246.2,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.9,
    cy: 246.4,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.2,
    cy: 246.3,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.9,
    cy: 248.9,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.9,
    cy: 248.2,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 884.8,
    cy: 246.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.1,
    cy: 246.2,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.3,
    cy: 247.5,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.4,
    cy: 245.9,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.8,
    cy: 248.3,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.6,
    cy: 245.6,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 997.1,
    cy: 245.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.1,
    cy: 246.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1014.9,
    cy: 246.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.6,
    cy: 249,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038.6,
    cy: 248.5,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051.2,
    cy: 247.4,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1059.8,
    cy: 246.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072,
    cy: 246.5,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.6,
    cy: 247,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.2,
    cy: 247.5,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1107.2,
    cy: 245.7,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.3,
    cy: 244.9,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.2,
    cy: 245,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.7,
    cy: 248.5,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.9,
    cy: 249.1,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.5,
    cy: 247.4,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171.4,
    cy: 244.9,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.5,
    cy: 246,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.5,
    cy: 245.1,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.8,
    cy: 259.6,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.4,
    cy: 256.2,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.2,
    cy: 259.2,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.6,
    cy: 258.6,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.9,
    cy: 257.5,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.9,
    cy: 259.9,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.8,
    cy: 258.3,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.6,
    cy: 256.9,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 718.9,
    cy: 256.3,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 731,
    cy: 259.2,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.5,
    cy: 257.7,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755.2,
    cy: 257.9,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.5,
    cy: 259.5,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.7,
    cy: 257.5,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.3,
    cy: 258.6,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.1,
    cy: 259.9,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.7,
    cy: 257.2,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.1,
    cy: 257.1,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.8,
    cy: 257.9,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.8,
    cy: 259.8,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.9,
    cy: 257.9,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.9,
    cy: 258.6,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.6,
    cy: 257.6,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898.2,
    cy: 255.9,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.5,
    cy: 259.4,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 917.4,
    cy: 259.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927.7,
    cy: 259.1,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.9,
    cy: 257.6,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.7,
    cy: 259.3,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008,
    cy: 258.6,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.4,
    cy: 256.3,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.1,
    cy: 258.1,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.4,
    cy: 257.8,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1052.1,
    cy: 257.6,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.3,
    cy: 257.6,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.6,
    cy: 259.9,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.4,
    cy: 258.2,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.7,
    cy: 256.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.2,
    cy: 258,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.8,
    cy: 260.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.3,
    cy: 256.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136,
    cy: 256.5,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.3,
    cy: 259.2,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.7,
    cy: 256.8,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.2,
    cy: 257.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.2,
    cy: 258.1,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.7,
    cy: 258.8,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 270.7,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.9,
    cy: 268,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.1,
    cy: 269.9,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.2,
    cy: 267.7,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.8,
    cy: 268,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 654.1,
    cy: 267.6,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.3,
    cy: 267.2,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676.5,
    cy: 270.6,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.4,
    cy: 267.8,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.2,
    cy: 268.9,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.9,
    cy: 268.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.6,
    cy: 271,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.3,
    cy: 271.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.7,
    cy: 267.7,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.2,
    cy: 270.9,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.3,
    cy: 270.5,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.2,
    cy: 270.1,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.4,
    cy: 267.2,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799,
    cy: 267.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.2,
    cy: 270,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.2,
    cy: 269.8,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.6,
    cy: 270.1,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839,
    cy: 270.9,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.5,
    cy: 270.3,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.9,
    cy: 270.4,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.9,
    cy: 269,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.1,
    cy: 270.6,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907.8,
    cy: 268.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920.1,
    cy: 271,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931,
    cy: 267.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940.9,
    cy: 270,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 951.5,
    cy: 266.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004,
    cy: 267.4,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.2,
    cy: 270.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.7,
    cy: 267.4,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.7,
    cy: 269.7,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.4,
    cy: 267.4,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.6,
    cy: 271,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.3,
    cy: 271,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.5,
    cy: 270,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114,
    cy: 269.9,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127,
    cy: 269,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.4,
    cy: 269.1,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.7,
    cy: 268.6,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 278.3,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.8,
    cy: 279.3,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.3,
    cy: 279.2,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.7,
    cy: 281.4,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.6,
    cy: 281,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.3,
    cy: 282,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.3,
    cy: 278.6,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.1,
    cy: 280.5,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 664.3,
    cy: 280.8,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676.2,
    cy: 277.8,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 687.9,
    cy: 279.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.1,
    cy: 278.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.7,
    cy: 281.4,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.2,
    cy: 279.2,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.9,
    cy: 279.1,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 741,
    cy: 279.3,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.3,
    cy: 281.3,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 764.9,
    cy: 281.7,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.7,
    cy: 278.3,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784,
    cy: 278.5,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.9,
    cy: 280.1,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.4,
    cy: 280.4,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.7,
    cy: 278.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832.1,
    cy: 281.1,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.3,
    cy: 278,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854.1,
    cy: 278.9,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.5,
    cy: 278.3,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.7,
    cy: 279.1,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.2,
    cy: 278.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.3,
    cy: 282.1,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.6,
    cy: 280.8,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 279,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938.2,
    cy: 282.1,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.6,
    cy: 278.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.6,
    cy: 278.9,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.1,
    cy: 279.9,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.2,
    cy: 281,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.2,
    cy: 278.4,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.1,
    cy: 281.5,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.8,
    cy: 278.3,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.8,
    cy: 281.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.7,
    cy: 279.2,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.5,
    cy: 289.5,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.3,
    cy: 291.9,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.4,
    cy: 290.4,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.2,
    cy: 291.7,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 289.3,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 653.9,
    cy: 289.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 664,
    cy: 292,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.1,
    cy: 289.3,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684.8,
    cy: 290.4,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.3,
    cy: 291.4,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.3,
    cy: 292.5,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.3,
    cy: 292.8,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.2,
    cy: 290.1,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.6,
    cy: 293,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.4,
    cy: 292.4,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.1,
    cy: 291.2,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776,
    cy: 293.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.9,
    cy: 289.3,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.4,
    cy: 293.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.2,
    cy: 293,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.9,
    cy: 288.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 290,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.3,
    cy: 290.4,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.3,
    cy: 292.9,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 292.7,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.9,
    cy: 292.4,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 289.9,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.4,
    cy: 291.4,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.8,
    cy: 291.9,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.7,
    cy: 289.2,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1017.1,
    cy: 293.1,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 291.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.5,
    cy: 290.6,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1103.6,
    cy: 290.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.4,
    cy: 290.7,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.8,
    cy: 289.2,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.9,
    cy: 289.4,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.9,
    cy: 292.4,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.7,
    cy: 289.8,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.1,
    cy: 299.9,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.3,
    cy: 301.3,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.1,
    cy: 304.1,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 653.2,
    cy: 303.5,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 302.3,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.6,
    cy: 302.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.1,
    cy: 300.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.2,
    cy: 300.3,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707,
    cy: 303,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721,
    cy: 302.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.7,
    cy: 303,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.4,
    cy: 302.5,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.8,
    cy: 302.3,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.5,
    cy: 301,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.5,
    cy: 303.6,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.6,
    cy: 303.9,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.6,
    cy: 301,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 300.1,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.1,
    cy: 302.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.9,
    cy: 303.8,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.3,
    cy: 302.6,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.4,
    cy: 303.3,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.4,
    cy: 299.8,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 876.1,
    cy: 303.3,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.4,
    cy: 300.3,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.8,
    cy: 302.7,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.4,
    cy: 299.9,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.8,
    cy: 301.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.7,
    cy: 303.4,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.6,
    cy: 303.8,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.1,
    cy: 303.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.6,
    cy: 301.3,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.7,
    cy: 303.6,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.5,
    cy: 300.2,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 314.8,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.7,
    cy: 314.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 664.9,
    cy: 311.4,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 677,
    cy: 313.2,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.2,
    cy: 314.5,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.9,
    cy: 314.9,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711.1,
    cy: 311.1,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.5,
    cy: 312.8,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.9,
    cy: 314.1,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.8,
    cy: 311.4,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753,
    cy: 315.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.7,
    cy: 312.8,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.3,
    cy: 312.8,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.1,
    cy: 314.3,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.6,
    cy: 312,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810.1,
    cy: 310.9,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.5,
    cy: 311.2,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.1,
    cy: 312.7,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.9,
    cy: 311.8,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.7,
    cy: 311.8,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861,
    cy: 311.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.1,
    cy: 312.5,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 887.1,
    cy: 312.4,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.2,
    cy: 313.4,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.3,
    cy: 311.7,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.4,
    cy: 313.5,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.5,
    cy: 310.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.2,
    cy: 313.1,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.3,
    cy: 311.8,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.1,
    cy: 325.6,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.2,
    cy: 325.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.9,
    cy: 322.6,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.1,
    cy: 324.2,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.8,
    cy: 324,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.2,
    cy: 324.7,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.9,
    cy: 323.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 326.2,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.8,
    cy: 324.7,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.5,
    cy: 325.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 325.3,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.7,
    cy: 324.5,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.1,
    cy: 323,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.5,
    cy: 324.2,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.1,
    cy: 325.5,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.9,
    cy: 323.6,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.4,
    cy: 322.1,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.7,
    cy: 324.8,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797,
    cy: 324.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.7,
    cy: 322.1,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.4,
    cy: 324.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.2,
    cy: 324,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.9,
    cy: 322.8,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.7,
    cy: 323.3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.9,
    cy: 325.8,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 876.1,
    cy: 323,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.1,
    cy: 322.3,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.4,
    cy: 322.1,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907,
    cy: 326,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.2,
    cy: 323.4,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.7,
    cy: 322.1,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.3,
    cy: 326,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411,
    cy: 336.5,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.7,
    cy: 335.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.2,
    cy: 334.2,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.2,
    cy: 334.9,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.1,
    cy: 336.4,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.7,
    cy: 333.6,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.1,
    cy: 336.3,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.8,
    cy: 335.6,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.2,
    cy: 335.7,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 687.1,
    cy: 332.9,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 335,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.6,
    cy: 333,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721.5,
    cy: 334.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.8,
    cy: 334.6,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.1,
    cy: 335.4,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.8,
    cy: 335.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.6,
    cy: 335.8,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.5,
    cy: 335.9,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788,
    cy: 334.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.8,
    cy: 334.5,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.7,
    cy: 336.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.2,
    cy: 335.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 336.8,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843.1,
    cy: 337,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.3,
    cy: 336.4,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.8,
    cy: 336.5,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.3,
    cy: 334.8,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 884.5,
    cy: 336.3,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896.7,
    cy: 335.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.6,
    cy: 332.9,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.9,
    cy: 334.8,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.1,
    cy: 335.2,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217,
    cy: 333.7,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.1,
    cy: 333.7,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.6,
    cy: 344.3,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.1,
    cy: 346,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.8,
    cy: 345.1,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.8,
    cy: 346.5,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.1,
    cy: 347.4,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.7,
    cy: 345.1,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.9,
    cy: 347.6,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.7,
    cy: 344.1,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742.8,
    cy: 344.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750.8,
    cy: 345,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.3,
    cy: 347.4,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.9,
    cy: 348,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.8,
    cy: 344.6,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.9,
    cy: 345.2,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.1,
    cy: 344.1,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.5,
    cy: 347.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.4,
    cy: 346.8,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.3,
    cy: 344.4,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.2,
    cy: 347.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.3,
    cy: 344.4,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.9,
    cy: 345.9,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.9,
    cy: 344,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.8,
    cy: 344.4,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.7,
    cy: 344.4,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.7,
    cy: 345,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.3,
    cy: 347.5,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.1,
    cy: 344.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193,
    cy: 343.9,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.4,
    cy: 355.1,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.1,
    cy: 358.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.4,
    cy: 358.1,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.6,
    cy: 355.9,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 357.2,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.2,
    cy: 355.6,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.6,
    cy: 358.8,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.3,
    cy: 356.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502.1,
    cy: 355.5,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.4,
    cy: 356.5,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.8,
    cy: 356.2,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.1,
    cy: 358.7,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.8,
    cy: 358.5,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.4,
    cy: 357.1,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.1,
    cy: 358.2,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.5,
    cy: 355.5,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 357.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.7,
    cy: 356.3,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.3,
    cy: 357.3,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.6,
    cy: 358.7,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874.7,
    cy: 358.1,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.3,
    cy: 358.1,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.4,
    cy: 359.2,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1113.8,
    cy: 356.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.3,
    cy: 357.8,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.6,
    cy: 355.2,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.4,
    cy: 367.9,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.7,
    cy: 365.8,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.3,
    cy: 368.1,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.3,
    cy: 370.2,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.3,
    cy: 369.5,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.4,
    cy: 369.3,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467,
    cy: 368,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.5,
    cy: 366.3,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.8,
    cy: 365.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 367.8,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513,
    cy: 369.9,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.6,
    cy: 368,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 764.4,
    cy: 368.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.2,
    cy: 368.1,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.2,
    cy: 368.7,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799,
    cy: 366,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 807.9,
    cy: 366.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.1,
    cy: 367.7,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.5,
    cy: 368.7,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 368.4,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.4,
    cy: 370.1,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.3,
    cy: 367.3,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.3,
    cy: 369.9,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.1,
    cy: 369.9,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.1,
    cy: 367.1,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.5,
    cy: 369.6,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1168.9,
    cy: 366.4,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1179.9,
    cy: 368.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.4,
    cy: 377.5,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.8,
    cy: 379.9,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.2,
    cy: 377.1,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.5,
    cy: 376.9,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 380.3,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.2,
    cy: 376.8,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 381.2,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.5,
    cy: 378.4,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.2,
    cy: 380.4,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502.1,
    cy: 378.4,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.8,
    cy: 381.2,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.7,
    cy: 378.7,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.2,
    cy: 380,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546.1,
    cy: 378.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.5,
    cy: 379.8,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.5,
    cy: 380.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.9,
    cy: 380.2,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.5,
    cy: 378.3,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 807.7,
    cy: 379.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 816.9,
    cy: 379.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.9,
    cy: 377.1,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.7,
    cy: 379.3,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854.2,
    cy: 380,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864,
    cy: 380.1,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.7,
    cy: 377.3,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.3,
    cy: 379.3,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.2,
    cy: 380.6,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170.5,
    cy: 379,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.8,
    cy: 377.9,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.1,
    cy: 380.1,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 391.1,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411,
    cy: 388.9,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.4,
    cy: 388,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.9,
    cy: 391,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 389.4,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.1,
    cy: 390.2,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.2,
    cy: 388.3,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.2,
    cy: 390.8,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.9,
    cy: 391.3,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.6,
    cy: 392.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.6,
    cy: 389.2,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.2,
    cy: 390.4,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.8,
    cy: 391.4,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.9,
    cy: 391.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.9,
    cy: 390,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.2,
    cy: 390.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 574.9,
    cy: 391.4,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.2,
    cy: 390.7,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.1,
    cy: 389.9,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.7,
    cy: 388.4,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 391.8,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.7,
    cy: 391.5,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.7,
    cy: 390.1,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.5,
    cy: 389.5,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.9,
    cy: 387.9,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.7,
    cy: 388.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.9,
    cy: 389.2,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1135.9,
    cy: 390.7,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1272,
    cy: 391.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.1,
    cy: 390.2,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290,
    cy: 388.8,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1324.5,
    cy: 391.4,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.8,
    cy: 399.6,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.3,
    cy: 401.5,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.2,
    cy: 398.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.8,
    cy: 400.8,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.1,
    cy: 402.5,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.2,
    cy: 401.4,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.2,
    cy: 402.1,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.9,
    cy: 400.6,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.5,
    cy: 402.2,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.9,
    cy: 401.3,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.1,
    cy: 403,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.9,
    cy: 401.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.3,
    cy: 400,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.8,
    cy: 400.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 401.4,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.1,
    cy: 402.7,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.2,
    cy: 400,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.2,
    cy: 401.1,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.5,
    cy: 399.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.7,
    cy: 401.7,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.4,
    cy: 400.6,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 400.6,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.9,
    cy: 400.7,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.9,
    cy: 402.7,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.2,
    cy: 398.9,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.9,
    cy: 399.7,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.5,
    cy: 400.3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171.8,
    cy: 402.8,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280.8,
    cy: 398.9,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.8,
    cy: 402.1,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302.8,
    cy: 402.7,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.9,
    cy: 413.3,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.9,
    cy: 411.6,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.9,
    cy: 412.5,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.4,
    cy: 412.5,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.7,
    cy: 411.6,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.3,
    cy: 409.9,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.5,
    cy: 411.9,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.7,
    cy: 409.9,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.3,
    cy: 409.8,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.7,
    cy: 410,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.2,
    cy: 411.9,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.3,
    cy: 410.8,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.6,
    cy: 412.6,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.1,
    cy: 410.2,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565.1,
    cy: 410.3,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576.1,
    cy: 410.7,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776,
    cy: 410.3,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.1,
    cy: 413.1,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.6,
    cy: 410.6,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 411.5,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.9,
    cy: 412.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.6,
    cy: 414,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.7,
    cy: 411.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.9,
    cy: 410.5,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.7,
    cy: 411.3,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.7,
    cy: 410.4,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1313.1,
    cy: 411.8,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.6,
    cy: 421.9,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 421.4,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.8,
    cy: 424,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.9,
    cy: 423.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.6,
    cy: 423.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.9,
    cy: 422.9,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.7,
    cy: 420.9,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.6,
    cy: 422.4,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.1,
    cy: 424.9,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510.4,
    cy: 423.2,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.4,
    cy: 422.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.7,
    cy: 424.4,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.4,
    cy: 424.8,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.8,
    cy: 421,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.4,
    cy: 423.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.6,
    cy: 422.1,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.8,
    cy: 424.5,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.9,
    cy: 421.4,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.7,
    cy: 424.5,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.2,
    cy: 421.9,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838.9,
    cy: 423.1,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.2,
    cy: 421.7,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.9,
    cy: 423.6,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.6,
    cy: 424.3,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.1,
    cy: 434.4,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.5,
    cy: 433.2,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.5,
    cy: 436,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458.1,
    cy: 434.3,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.3,
    cy: 434.7,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 434.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.8,
    cy: 433.5,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501,
    cy: 433.3,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.8,
    cy: 432.2,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.2,
    cy: 432.5,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 433.1,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.4,
    cy: 433.6,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.1,
    cy: 434.1,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.2,
    cy: 432.2,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.7,
    cy: 431.8,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 434.5,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.7,
    cy: 432.2,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 435.7,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.4,
    cy: 433.6,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.1,
    cy: 432,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.8,
    cy: 434.5,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.1,
    cy: 434,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.4,
    cy: 431.8,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 917.3,
    cy: 434.6,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.7,
    cy: 434.9,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247.5,
    cy: 433.9,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.9,
    cy: 435.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.9,
    cy: 435,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.5,
    cy: 447.1,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.9,
    cy: 444.8,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.4,
    cy: 445.3,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.1,
    cy: 444.1,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.3,
    cy: 446.4,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491,
    cy: 445.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 444.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.9,
    cy: 445.7,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524,
    cy: 446.1,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.5,
    cy: 444,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542,
    cy: 446.2,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.7,
    cy: 444.5,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.5,
    cy: 444.6,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.1,
    cy: 446,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.8,
    cy: 444.6,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.8,
    cy: 443.5,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.9,
    cy: 445.6,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.3,
    cy: 444.9,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.6,
    cy: 445.4,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.3,
    cy: 445.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.2,
    cy: 444.6,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.5,
    cy: 443.1,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.1,
    cy: 446.8,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 917.4,
    cy: 445.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215.9,
    cy: 444.5,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1225.8,
    cy: 444.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.8,
    cy: 444.1,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247,
    cy: 443.6,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.6,
    cy: 444.5,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1270.3,
    cy: 446.4,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1294,
    cy: 446.9,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1436.2,
    cy: 445.1,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.2,
    cy: 456.3,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 454.5,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 456.5,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 456.5,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.3,
    cy: 457.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.1,
    cy: 455.5,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.8,
    cy: 456.4,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.5,
    cy: 457.9,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.8,
    cy: 455,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.8,
    cy: 457,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.7,
    cy: 455.4,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775,
    cy: 458.2,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788,
    cy: 455.4,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.8,
    cy: 456.8,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.1,
    cy: 457.8,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 458.1,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.4,
    cy: 457.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.1,
    cy: 456.1,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.6,
    cy: 455.9,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897,
    cy: 456.4,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.7,
    cy: 455.3,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.8,
    cy: 456.4,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1225.3,
    cy: 457.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.8,
    cy: 454.1,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.9,
    cy: 454.4,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.9,
    cy: 454.6,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.9,
    cy: 456.7,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282,
    cy: 455.2,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290,
    cy: 455.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1304.8,
    cy: 456.2,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.4,
    cy: 466,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.1,
    cy: 465.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.8,
    cy: 465.9,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 466.2,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.7,
    cy: 464.9,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.9,
    cy: 467.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.8,
    cy: 468.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.1,
    cy: 468.1,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.5,
    cy: 465.7,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.7,
    cy: 467.7,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.3,
    cy: 465.1,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.4,
    cy: 467.6,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794.9,
    cy: 465.7,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.3,
    cy: 464.9,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.7,
    cy: 465.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.4,
    cy: 465.4,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.3,
    cy: 466.8,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.2,
    cy: 468.8,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.3,
    cy: 467.6,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.9,
    cy: 468,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.8,
    cy: 465.7,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.8,
    cy: 464.9,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1216.4,
    cy: 468.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.6,
    cy: 465.1,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1234.9,
    cy: 468.6,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247.4,
    cy: 466.3,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.9,
    cy: 467.1,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.2,
    cy: 465.5,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279.3,
    cy: 467.9,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.8,
    cy: 465,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1301.8,
    cy: 467.1,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1313,
    cy: 467,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1381.9,
    cy: 468.2,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.1,
    cy: 476.7,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.8,
    cy: 478.1,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.8,
    cy: 476.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.5,
    cy: 480.1,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.6,
    cy: 479.3,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.3,
    cy: 478.4,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 476.8,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.1,
    cy: 477.5,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.6,
    cy: 477.6,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.3,
    cy: 476.4,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.1,
    cy: 478.2,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 807.9,
    cy: 476.4,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.2,
    cy: 478.3,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830.9,
    cy: 479.8,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.1,
    cy: 479.5,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.2,
    cy: 477.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.5,
    cy: 477.8,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 476.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.4,
    cy: 476.7,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.3,
    cy: 476.3,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215.5,
    cy: 476.7,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226,
    cy: 478.9,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237,
    cy: 479.1,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1249.2,
    cy: 477.8,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1257.7,
    cy: 476,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1270.8,
    cy: 477.4,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280.1,
    cy: 476.2,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.6,
    cy: 479.7,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302.9,
    cy: 479.5,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1315.5,
    cy: 476.9,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1323.8,
    cy: 479.7,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.2,
    cy: 486.9,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.7,
    cy: 491,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.6,
    cy: 487,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.9,
    cy: 490.3,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.6,
    cy: 488.7,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.7,
    cy: 489.8,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510.1,
    cy: 489.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.8,
    cy: 488.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784,
    cy: 489.9,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.3,
    cy: 487.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.1,
    cy: 491.1,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.3,
    cy: 487.1,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.6,
    cy: 489.7,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.6,
    cy: 488.7,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.5,
    cy: 487.2,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1179.8,
    cy: 487.9,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194,
    cy: 490.3,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.8,
    cy: 488.7,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.6,
    cy: 487.6,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.9,
    cy: 491.2,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.4,
    cy: 488.6,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.2,
    cy: 489,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.1,
    cy: 488.6,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.7,
    cy: 490.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.7,
    cy: 488.1,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1291.8,
    cy: 487.8,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 487.4,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1313.9,
    cy: 486.9,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1324.8,
    cy: 488.8,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.2,
    cy: 498.7,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.4,
    cy: 499.4,
    r: 1.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.5,
    cy: 501.3,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.9,
    cy: 499.3,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.1,
    cy: 498.7,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 502.1,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.8,
    cy: 499.2,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521,
    cy: 499.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787,
    cy: 500.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.1,
    cy: 498,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.1,
    cy: 500.5,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.3,
    cy: 498.8,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.3,
    cy: 501,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.5,
    cy: 500.1,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.8,
    cy: 498.9,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194.5,
    cy: 497.9,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1202.8,
    cy: 497.9,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217,
    cy: 500.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.5,
    cy: 502.2,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.2,
    cy: 501.8,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1245.9,
    cy: 500.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.3,
    cy: 499.5,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.7,
    cy: 501.2,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1281,
    cy: 499,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.5,
    cy: 498.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1303.2,
    cy: 500.1,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1312.6,
    cy: 500.1,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1323.1,
    cy: 499.1,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 511.4,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.5,
    cy: 510.5,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.3,
    cy: 511.7,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.8,
    cy: 510.7,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.5,
    cy: 510.1,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.6,
    cy: 512.7,
    r: 1.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.7,
    cy: 511.7,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.3,
    cy: 512.3,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.9,
    cy: 512.9,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.3,
    cy: 510.4,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 509.8,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.3,
    cy: 510.1,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.3,
    cy: 510.5,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1202.5,
    cy: 509.2,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215.2,
    cy: 510.1,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.8,
    cy: 512.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238,
    cy: 511.1,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.6,
    cy: 510.3,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.9,
    cy: 511.2,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.7,
    cy: 510.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.5,
    cy: 513.2,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293,
    cy: 512.6,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302.1,
    cy: 509.1,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1312.8,
    cy: 511,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1326.2,
    cy: 512,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.9,
    cy: 520,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.7,
    cy: 522.2,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.4,
    cy: 523.9,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.8,
    cy: 524.2,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.3,
    cy: 523.4,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.9,
    cy: 524.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501,
    cy: 521.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.6,
    cy: 522.6,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.5,
    cy: 522.6,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 821.2,
    cy: 520,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.7,
    cy: 520.7,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.4,
    cy: 522.6,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.5,
    cy: 524,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1216.4,
    cy: 523.4,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.2,
    cy: 519.9,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.3,
    cy: 520.7,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3,
    cy: 523.3,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.2,
    cy: 520.5,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305.1,
    cy: 520.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1315.3,
    cy: 522.4,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1326.6,
    cy: 523,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.3,
    cy: 530.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.3,
    cy: 533.3,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.8,
    cy: 533.2,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.6,
    cy: 531.7,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.4,
    cy: 532.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 534.8,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1192.9,
    cy: 531,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1270.6,
    cy: 531.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1281,
    cy: 534.5,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1289.9,
    cy: 531.7,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1301.1,
    cy: 534.5,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1314.8,
    cy: 531.9,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1414.2,
    cy: 534.2,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.1,
    cy: 545.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 545.8,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.5,
    cy: 545.5,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.9,
    cy: 542,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.8,
    cy: 542.4,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.3,
    cy: 542.4,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.7,
    cy: 545.4,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 543.2,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1315.3,
    cy: 543.1,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1424.4,
    cy: 544,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.5,
    cy: 556.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.4,
    cy: 553.7,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458.1,
    cy: 556.3,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.8,
    cy: 554.4,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1422.3,
    cy: 555.9,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.9,
    cy: 566.9,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.4,
    cy: 567.9,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.6,
    cy: 567.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.4,
    cy: 566.2,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 565.8,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1411.6,
    cy: 567.2,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.2,
    cy: 577,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.8,
    cy: 578.5,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.1,
    cy: 575.4,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.2,
    cy: 578.7,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1400.2,
    cy: 575.8,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 587.3,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.5,
    cy: 588.2,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.9,
    cy: 589.4,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.9,
    cy: 589.7,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.6,
    cy: 601.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.8,
    cy: 598.2,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.9,
    cy: 597.2,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.3,
    cy: 611.3,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 609.6,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.5,
    cy: 611.3,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.6,
    cy: 621.2,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.1,
    cy: 620.3,
    r: 1.43
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMapDots);
export default __webpack_public_path__ + "static/media/world-map-dots.98a84f07e8126d1f99b80c47ece72399.svg";
export { ForwardRef as ReactComponent };